module.exports = __webpack_public_path__ + "img/france-skin-connective-and-musculoskeletal-diseases-male.724e9f98.png";